import Router, { Route } from 'vue-router';
import Home from './views/Home.vue';
import Schedule from '@/modules/schedule/Schedule.vue';
import Events from '@/modules/events/Events.vue';
import EventEdit from '@/modules/events/components/EventEdit.vue';
import Players from '@/modules/players/Players.vue';
import Teams from '@/modules/teams/Teams.vue';

import { authGuard } from './auth/authGuard';
import Vue from 'vue';

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: Schedule,
    },
    {
      path: '/schedule/matchDays/new',
      name: 'newMatchDay',
      component: Schedule, // => MatchDayEdit,
    },
    {
      path: '/events',
      name: 'events',
      beforeEnter: authGuard,
      component: Events,
    },
    {
      path: '/events/new',
      name: 'newEvent',
      component: EventEdit,
      props: false,
    },
    {
      path: '/events/:eventId/edit',
      name: 'eventEdit',
      component: EventEdit,
      props: true,
    },
    {
      path: '/teams',
      name: 'teams',
      component: Teams,
    },
    {
      path: '/players',
      name: 'players',
      component: Players,
    },
    // {
    //   path: '/about',
    //   name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
  ],
});

router.afterEach((to, _) => {
  Vue.nextTick(() => {
    if ((document as any).hideMobileMenu) {
      (document as any).hideMobileMenu();
    }
    // document.title = to.meta.title ? `${to.meta.title} - Efficiency Management` : 'Efficiency Management';
  });
});

export default router;
